import { atom } from "@reatom/framework";
import { withLocalStorage } from "@reatom/persist-web-storage";

export const isAsideCollapse = atom(false, "asideCollapse").pipe(
  withLocalStorage("asideCollapse"),
);
